import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取全量品牌列表
 *      status：0-下架，1-上架
 *      cat_id：1-蛋糕，4-电子券，5-零食，8-鲜花，10-水果
 * @param params
 */
export const getFullBrandListApi = (params:object = {}) => $http.get('/admin/brands/getBrandList', params)

/**
 * 获取品牌列表
 * id_show=1 会将对应的品牌ID与品牌名称连接进行返回 
 * if_body 0 实物 1 电子券 2全部（默认） 
 * @param params
 */
export const getBrandListApi = (params:object = {}) => $http.get('/admin/shop_product/getBrandList', params)

/**
 * 获取特殊品牌列表（某渠道、对接方指定必要的品牌）
 * @param params
 */
export const getSpecialBrandListApi = (params:object = {}) => $http.get('/cake_api/special_brand', params)

/**
 * 品牌筛选
 * @param params
 * cat_id：分类ID
 */
export const getFilterBrandList = (params:object = {}) => $http.get('/admin/brands/get_brand_list', params)

/**
 * 获取品牌详情
 */
export const getBrandInfoApi = (brand_id) => $http.get('/cake_api/brand_info', { brand_id })

/**
 * 获取当前登录商户关联品牌列表
 *  id_show=1 会将对应的品牌ID与品牌名称连接进行返回
 * */ 
export const getMerchantBrandListApi = (params:object = {}) => $http.get('/admin/shop_product/getBrandList', params)

/**
 * 获取配规详情
 *  item_type：配规类型：brand-品牌配规，city-城市配规，product-商品配规
 *  item_id：品牌配规和城市配规为品牌id，商品配规为商品id
 *  city_id：城市ID
*/
export const getRuleInfoApi = (item_type: string, item_id: any, city_id: any, distribution_rule_id: any) => $http.get('/admin/brands/get_distribution_rule', { item_type, item_id, city_id, distribution_rule_id })

/**
 * 获取品牌配规信息
 *  brand_id：品牌ID
*/
export const getBrandRuleInfoApi = (brand_id: any) => $http.get('/distribution/listDeliveryByBrand', { brand_id })

/**
 * 保存配规
 * */ 
export const saveRuleApi = (data: object = {}) => $http.post('/admin/brands/send_distribution_rule', data)

/**
 * 配规运费审核撤回
 * distribution_rule_id：当前配规 id
 * d_id：当前记录标识
 * ship_area_type：类型，1-地图区域、2-门店半径
 * */ 
export const deliveryFeeRecallApi = (distribution_rule_id, d_id, ship_area_type) => $http.post('/admin/brands/revoke_freight', { distribution_rule_id, d_id, ship_area_type })

/**
 * 删除配置
 *  id: 配规ID
 *  city_id：城市ID
 *  brand_id：品牌ID
 * */
export const delRuleApi = (id, city_id, brand_id) => $http.post('/admin/brands/del_distribution_rule', { id, city_id, brand_id })

/**
 * 保存地图
 * */
export const saveMapApi = (data: object = {}) => $http.post('/admin/brands/send_ship_area', data)

/**
 * 获取附件列表
 */
export const getAttachmentListApi = (params:object = {}) => $http.get('/admin/brands/getBrandChargesList', params)

/**
 * 新增、编辑附件
 * */ 
export const saveAttachmentApi = (data: object = {}) => $http.post('/admin/brands/sendBrandChargesSave', data)

/**
 * 附件上下架
 * */ 
export const updateAttachmentStatusApi = (id: any, status: number) => $http.post('/admin/brands/sendBrandChargesStatus', { id, status })

/**
 * 获取指定品牌开通城市列表
 */
export const getOpenCityListByBrandApi = (params:object = {}) => $http.get('/cake_api/getOpenCityList', params)

/**
 * 获取所有城市列表，根据品牌标识是否已开通（标注已开通，置为 disabled）
 */
export const getCityListWithDisabledApi = (brand_id: string) => $http.get('/cake_api/getNoOpenCityList', { brand_id })

/**
 * 新增开通城市
 */
export const addOpenCityApi = (brand_id: string, city_ids: string) => $http.post('/cake_api/openCitys', { brand_id, city_ids })

/**
 * 删除开通城市
 */
export const delOpenCityApi = (brand_id: string, city_id: number) => $http.post('/cake_api/delCityListByBrandId', { brand_id, city_id })

/****************************************** 二级品牌管理 -- begin ******************************************/
/**
 * 获取二级品牌列表
 * @param status 1:上架 2:下架
 * @param secondary_name 二级品牌名称
 * @param is_page 是否分页 2:不分页 其他:分页
 */
export const getSecondBrandListApi = (params: object = {}) => $http.get('/brand/sw_secondary_brands_list', params)
/**
 * 修改二级品牌上下架状态
 */
export const updateSecondBrandStatusApi = (secondary_id, status) => $http.post('/brand/sw_secondary_brands_status', { secondary_id, status })
/**
 * 新增/编辑二级品牌
 */
export const saveSecondBrandApi = (data: object = {}) => $http.post('/brand/sw_secondary_brands_add', data)
/**
 * 获取二级品牌信息
 */
export const getSecondBrandInfoApi = (secondary_id: string) => $http.get('/brand/sw_secondary_brands_details', { secondary_id })
/**
 * 获取二级品牌关联的供应商列表
 */
export const getSecondBrandSupplierListApi = (params: object = {}) => $http.get('/brand/secondary_brands_show', params)
/****************************************** 二级品牌管理 -- end ******************************************/

/**
 * 获取三级分类列表
 * level：1-一级，2-二级，3-三级
 * status：1-上架，0-下架（全部：不传该字段）
 */
export const getCatListApi = (level:number, status:any = '') => $http.get('/cake_api/getCatList', {level, status})

/**
 * 获取电子券品牌（按 coupon_sort 值倒序）
 * brand_id：品牌ID
 */
export const getCouponBrandListApi = (params: object = {}) => $http.get('/cake_api/getCouponBrand', params)

/**
 * 保存电子券品牌排序
 * brand_id：品牌ID
 * coupon_sort：排序值
 */
export const saveCouponSortApi = (brand_id: string, coupon_sort: number) => $http.get('/cake_api/saveCouponBrand', { brand_id, coupon_sort })

/**
 * 拓展品牌修改合作方式、结算方式、结算周期等
 */
export const updateExpandBrandApi = (data) => $http.post('/brand/upPaymentMethod', data)

/**
 * 获取拓展品牌的操作日志
 */
export const getExpandBrandLogApi = (brand_id) => $http.get('/brand/paymentMethodLog', { brand_id })

/**
 * 保存品牌详情
 */
export const saveBrandDetailApi = (data: object = {}) => $http.post('/opsapi/brandEdit', data)

/*************************************** 特殊配规 -- begin ******************************************/
/**
 * 获取特殊配规列表
 * */ 
export const getSpecialRuleListApi = (params: object = {}) => $http.get('/distribution/listDeliveryRule', params)
/**
 * 获取特殊配规详情
 * */ 
export const getSpecialRuleDetailApi = (id: any) => $http.get('/distribution/getDeliveryInfo', { id })
/**
 * 保存特殊配规
 * */ 
export const saveSpecialRuleApi = (data: object = {}) => $http.post('/distribution/addDeliveryRule', data)
/**
 * 特殊配规-终止
 * */ 
export const cancelSpecialRuleApi = (id: any) => $http.post('/distribution/operDeliveryRule', { id })
/**
 * 获取特殊配规审核列表
 * */ 
export const getSpecialRuleCheckListApi = (params: object = {}) => $http.get('/distribution/listApprovalDeliveryRule', params)
/**
 * 获取特殊配规审核详情
 * */ 
export const getSpecialRuleCheckDetailApi = (id: any) => $http.get('/distribution/getApprovalDeliveryRuleInfo', { id })
/**
 * 特殊配规审核
 *      id：配规ID
 *      approval_status：审核状态，2-通过，3-驳回
 *      reject_reason：驳回原因
 * */ 
export const checkSpecialRuleApi = (id: any, approval_status: number, reject_reason: string = '') => $http.post('/distribution/doApprovalDeliveryRule', { id, approval_status, reject_reason })

/**
 *添加配规标识，修改时增加id参数
 * */ 
export const addBdyProductApi = (params: object = {}) => $http.get('/sys/admin/addBdyProduct', params)

//获取配规标识列表
export const getBdyProductListApi = (params: object = {}) => $http.get('/sys/admin/listBdyProduct', params)

// 配规标识终止接口
export const operBdyProductApi = (params: object = {}) => $http.get('/sys/admin/operBdyProduct', params)
/*************************************** 特殊配规 -- end ******************************************/

/**
 * 一键上架商品/门店
 * @param brand_id  必填    品牌ID
 * @param type      必填    1-商品，2-门店
 * */ 
export const oneClickListingApi = (brand_id: string | number, type: number) => $http.post(type === 1 ? '/opsapi/up_product' : '/opsapi/up_brand_shop', { brand_id })

/**
 * 根据品牌ID获取品牌列表
 * @param brand_ids  必填    品牌ID
 * */ 
export const getBrandListByIdsApi = (brand_ids: string) => $http.get('/sys/admin/getBrandList', { brand_ids })

/**
 * 查询品牌下的所有账号
 * @param brand_id  必填    品牌ID
 * */ 
export const getBrandAccountListApi = (brand_id: string) => $http.get('/opsapi/userList', { brand_id })
